import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Icon,
} from "@chakra-ui/react";
import { ReactNode } from "react";
import { MdError } from "react-icons/md";

const CheckoutSectionWrapper = ({
  children,
  isValid: isValid = true,
  isDirty: isDirty = false,
  title,
  icon,
}: {
  children: ReactNode;
  isValid?: boolean;
  isDirty?: boolean;
  title: string;
  icon?: any;
}) => {
  return (
    <Accordion
      allowMultiple
      defaultIndex={[0]}
      className="rounded-xl overflow-hidden border border-neutral-60  dark:border-white/[.16] dark:bg-white/[.05] bg-white/[.6]"
    >
      <AccordionItem
        _first={{ borderTop: "none" }}
        _last={{ borderBottom: "none" }}
        bg="transparent"
      >
        <h2 className="border-b border-neutral-60 dark:text-white dark:border-white/[.16]">
          <AccordionButton bg="transparent">
            <div className="flex flex-row flex-grow py-4 items-center gap-3">
              {icon && (
                <Icon as={icon} w={5} h={5} color={"primary.300"}></Icon>
              )}
              <h2 className="flex flex-row items-center flex-grow text-lg font-semibold dark:text-white">
                {title}
                {!isValid && isDirty && <MdError className="mx-4 text-error" />}
              </h2>
            </div>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel
          p={4}
          style={{
            backgroundColor: "transparent",
            padding: "1rem",
          }}
        >
          {children}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default CheckoutSectionWrapper;
